import { render, staticRenderFns } from "./taxCategories.vue?vue&type=template&id=6c367d3d&"
import script from "./taxCategories.vue?vue&type=script&lang=js&"
export * from "./taxCategories.vue?vue&type=script&lang=js&"
import style0 from "./taxCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports